import type { IOpportunityMSService } from '@/types/opportunity/models'

export function TypeAndProductLevelDescr(
  o: IOpportunityMSService
): string | undefined {
  if (!o || !o.origin || !o.product || !o.product.level) {
    return undefined
  }
  const originAndProductLevelDescr = (
    o.origin.label +
    '\n' +
    o.product.level.label
  ).replace('Service', '')

  return originAndProductLevelDescr
}
